// PrivateRoute.jsx
import { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { terminateAuthSession } from '../../services/auth/authSessionTermination';
import { ROUTES } from '../../utils/constants/routes';

const PrivateRoute = () => {
  const navigate = useNavigate();
  const terminatingRef = useRef(false);
  const mountedRef = useRef(false);
  const [isTerminating, setIsTerminating] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    let shouldTerminate = !token;
    try {
      if (token) {
        const decoded = jwtDecode(token);
        shouldTerminate = Boolean(decoded.exp && decoded.exp < Date.now() / 1000);
      }
    } catch (e) {
      shouldTerminate = true;
    }

    if (!shouldTerminate || terminatingRef.current) return;

    terminatingRef.current = true;
    setIsTerminating(true);
    terminateAuthSession({
      navigateToLogin: () => navigate(ROUTES.signIn, { replace: true }),
    }).then((result) => {
      if (
        result?.alreadyTerminated &&
        !result?.navigationAttempted &&
        mountedRef.current
      ) {
        navigate(ROUTES.signIn, { replace: true });
      }
    }).finally(() => {
      if (mountedRef.current) {
        setIsTerminating(false);
      }
    });
  }, [navigate, token]);

  if (!token) return null;
  if (isTerminating) return null;

  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp < Date.now() / 1000) return null;
  } catch (e) {
    return null;
  }

  return <Outlet />;
};

export default PrivateRoute;
